import { useField } from "formik";
import { DatePicker } from "neetoui";

import { TIME_FORMAT } from "./constants";
import { disabledTime } from "./utils";

const FormikDatePicker = ({ name, disabledDate, ...props }) => {
  const [field, meta, { setValue, setTouched }] = useField(name);

  return (
    <DatePicker
      showTime
      timeFormat={TIME_FORMAT}
      {...{ ...field, ...meta, disabledDate }}
      data-testid={props["data-testid"]}
      timePickerProps={{ disabledTime }}
      onBlur={() => !meta.touched && setTouched(true)}
      onChange={date => {
        setValue(date || undefined);
        if (!meta.touched) setTouched(true);
      }}
      {...props}
    />
  );
};

export default FormikDatePicker;
